import { render, staticRenderFns } from "./CMAssignCourseConfiguration.vue?vue&type=template&id=d5d10496&lang=pug"
import script from "./CMAssignCourseConfiguration.vue?vue&type=script&lang=js"
export * from "./CMAssignCourseConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports